export default "__VITE_ASSET__Dvq1JMiL__"